/* This file is lifted from suite-front-end/src/utils/api/searchSuggestApi.js */

let isRunningSuggestLookup = false;
let isSearchSuggestAvailable = true;
let lastSearchSuggestTerm = null;
let nextTermInQueue = null;

function shouldLookUpSearchSuggest(term) {
  nextTermInQueue = null;
  if (isSearchSuggestAvailable) {
    if (lastSearchSuggestTerm === term) {
      return false;
    }
    if (term.length > 2 && term.length < 20) {
      if (isRunningSuggestLookup) {
        nextTermInQueue = term;
        return false;
      }
      return true;
    }
  }
  return false;
}

export default function getSearchSuggestions(term, $deApi) {
  if (shouldLookUpSearchSuggest(term)) {
    isRunningSuggestLookup = true;

    const resp = $deApi
      .get(`/search/suggest?text=${encodeURIComponent(term)}`, {
        headers: {
          'X-Request-Deadline': 's=0.5',
        },
      })
      .then((response) => {
        lastSearchSuggestTerm = term;
        return response.data;
      })
      .catch(() => {
        isSearchSuggestAvailable = false;
      })
      .finally(() => {
        isRunningSuggestLookup = false;
        if (nextTermInQueue && lastSearchSuggestTerm !== nextTermInQueue) {
          getSearchSuggestions(nextTermInQueue);
        }
      });

    return resp;
  }
  return false;
}
